import React from "react";

// Styles
import styles from "./divider.module.scss";

interface DividerProps {
  className?: string;
}

const Divider: React.FC<DividerProps> = ({ className }) => {
  return <div className={`${styles.divider} ${className}`} />
}

export default Divider;
